import React from 'react';

import NozomiReconciliationContainer from '@totem/components/administration/reconciliation/nozomi/NozomiReconciliationContainer';
import NozomiReconciliationTabs from '@totem/components/administration/reconciliation/nozomi/NozomiReconciliationTabs';
import VantageAssetCountsContainer from '@totem/components/administration/reconciliation/nozomi/vantage/VantageAssetCountsContainer';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const NozomiReconciliationPage = () => (
  <ContentLayout>
    <NozomiReconciliationContainer>
      <VantageAssetCountsContainer>
        <NozomiReconciliationTabs />
      </VantageAssetCountsContainer>
    </NozomiReconciliationContainer>
  </ContentLayout>
);

export default NozomiReconciliationPage;
